import script from "./promoBannerFull.vue?vue&type=script&setup=true&lang=js"
export * from "./promoBannerFull.vue?vue&type=script&setup=true&lang=js"

import "./promoBannerFull.vue?vue&type=style&index=0&id=741980f6&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741980f6"]])

export default __exports__